import { render, staticRenderFns } from "./declareList-ing.vue?vue&type=template&id=9dfa418a"
import script from "./declareList-ing.vue?vue&type=script&lang=js"
export * from "./declareList-ing.vue?vue&type=script&lang=js"
import style0 from "./declareList-ing.vue?vue&type=style&index=0&id=9dfa418a&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9dfa418a')) {
      api.createRecord('9dfa418a', component.options)
    } else {
      api.reload('9dfa418a', component.options)
    }
    module.hot.accept("./declareList-ing.vue?vue&type=template&id=9dfa418a", function () {
      api.rerender('9dfa418a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/courseDeclare/declareList-ing.vue"
export default component.exports